<template>
  <div class="defaultInvoice">
    <vxe-grid
      class="invoiceTable"
      :ref="refname"
      resizable
      show-footer
      show-footer-overflow
      height="300"
      :footer-method="footerMethod"
      :columns="names"
      :data="tableData"
      :edit-config="{trigger: 'click', mode: 'row',showIcon:false}"
      :loading="loading"
      :edit-rules="validRules"
      keep-source
      @cell-click="currentChangeEvent"
    >
      <template v-slot:invoiceItemId="{row}">
        <span>{{ row.invoiceItemId| dictFilter(dicts)  }}</span>
      </template>

      <template v-slot:invoiceType="{row}">
        <span>{{ row.invoiceType| dictFilter(dicts)  }}</span>
      </template>
      <template v-slot:invoiceMedium="{row}">
        <span>{{ row.invoiceMedium| dictFilter(dicts)  }}</span>
      </template>
      <template v-slot:operateMode="{row}">
        <span>{{ row.operateMode| dictFilter(dicts)  }}</span>
      </template>

      <template v-slot:operation="{ row,rowIndex }" width="120px" v-if="invoiceActive === 3">
        <el-button type="text" @click="deleteData(row,rowIndex)">删除</el-button>
      </template>
    </vxe-grid>
    <div class="tancengBtn">
      <el-button type="primary" size="small" @click="submitData">确定</el-button>
      <el-button type="" size="small" @click="backPrev">取消</el-button>
    </div>
  </div>
</template>

<script>
  import {saveSplitInvoice} from "@/api/biz/bill/invoice"
  import {mapGetters} from 'vuex';
  import {floatSum,formatFloat} from "@/util/util"
  export default {
    name: "defaultInvoice",
    props: {
      invoiceActive: {
        type: Number,
        default: 1
      },
      sumItem: {
        type: Array,
        default: () =>([])
      },
      names: {
        type: Array,
        default: () =>([])
      },
      invoiceItemList: {
        type: Array,
        default: () =>([])
      },
      invoiceTitleList: {
        type: Array,
        default: () =>([])
      },
      datas: {
        type: Array,
        default: () =>([])
      },
      refname: {
        type: String,
        default: ''
      },
      noticeId: {
        type: String,
        default: '',
      },
      validRules: {
        type: Object,
        default: () =>({})
      }
    },
    watch:{
      datas:{
        handler:function(val,oldval){
          if(val!=oldval){
            this.$nextTick(()=>{
              this.datasCopy = JSON.parse(JSON.stringify(this.datas));
              this.tableData = JSON.parse(JSON.stringify(this.datas));
              // //计算数据
              // const tableData = this.tableData.filter(item => item.totalAmount && item.taxRate)
              // debugger
              // // 计算销项税
              //   this.computeTax(tableData)
                this.updateData()
            })
          }
        },
        immediate:true,//关键
        deep:true
      },
      names:{
        handler:function(val,oldval){
          if(val!=oldval){
            this.$nextTick(()=>{
              this.updateData()
            })
          }
        },
        immediate:true,//关键
        deep:true
      },
      invoiceItemList:{
        handler:function(val,oldval){
          if(val!=oldval){
            this.$nextTick(()=>{
              this.updateData()
            })
          }
        },
        immediate:true,//关键
        deep:true
      },
      invoiceTitleList:{
        handler:function(val,oldval){
          if(val!=oldval){
            this.$nextTick(()=>{
              this.updateData()
            })
          }
        },
        immediate:true,//关键
        deep:true
      },
    },
    data() {
      return {
        datasCopy:null,
        tableData:null,
      }
    },
    computed: {
      ...mapGetters(['dicts']),
    },
    created(){
      this.updateData()
    },
    mounted() {
    },
    methods: {
      currentChangeEvent ({ row }) {
        if(row.invoiceType=='30300001'){//发票类型是增值税，不能选一般纳税人发票抬头
          for(var k=0;k<this.invoiceTitleList.length;k++){
            let title=this.invoiceTitleList[k];
            if(title.generalTaxpayer!="10020001"){
              this.invoiceTitleList[k].disabled=true;
            }else{
              this.invoiceTitleList[k].disabled=false;
            }
          }
        }else{
          for(var k=0;k<this.invoiceTitleList.length;k++){
            let title=this.invoiceTitleList[k];
            this.invoiceTitleList[k].disabled=false;
          }
        }
      },
      computeTax(tableData){
        if(!tableData){
          tableData = this.tableData;
        }
        tableData.map((column) => {
          if(column.invoiceItemId=="30410001") {//服务费需要算销项税
            column.saleTax = Math.round(parseFloat(formatFloat(column.totalAmount))/1.06 * 0.06*100)/100;
            column.amount = Math.round(parseFloat(formatFloat(column.totalAmount)*100 - column.saleTax*100))/100;
            column.saleTax = column.saleTax.toFixed(2);
            column.amount = column.amount.toFixed(2);
          }else{
            column.amount = column.totalAmount;
          }
          return column
        });
      },
      updateData(){
        if (this.invoiceActive == 3 && this.$refs[this.refname]) {
          this.$nextTick(() => {
            let selects = ['invoiceTitleId', 'invoiceItemId'];
            if(this.$refs[this.refname].getColumnByField(selects[0])){
              for (var i = 0; i < selects.length; i++) {
                let column = this.$refs[this.refname].getColumnByField(selects[i])
                if (selects[i] == "invoiceTitleId") {

                  column.editRender.options = this.invoiceTitleList
                }else if (selects[i] == "invoiceItemId") {
                  // 将此条不存在的下拉项置灰
                  let types = [];
                  for(var i = 0;i < this.datasCopy.length;i++){
                    if(types.indexOf(this.datasCopy[i].invoiceItemId) == -1){
                      types.push(this.datasCopy[i].invoiceItemId)
                    }
                  }
                  for(var i = 0;i < this.invoiceItemList.length;i++){
                    if(types.indexOf(this.invoiceItemList[i].invoiceItemId) == -1 && this.invoiceItemList[i].invoiceItemId != ""){
                      this.invoiceItemList[i].disabled = true;
                    }else{
                      if(this.invoiceItemList[i].disabled == true){
                        this.invoiceItemList[i].disabled = false
                      }
                    }
                  }
                  column.editRender.options = this.invoiceItemList;
                }
              }
            }
          })
        }
      },
      insertEvent(row) {
        const newRow = JSON.parse(JSON.stringify(this.datasCopy[0]));
        const billType = newRow.billType;
        Object.keys(newRow).forEach(key => newRow[key]= '');
        newRow._XID = "row_"+ new Date().getTime();

        this.$refs[this.refname].createRow({
          isNew: true,
          billType: billType
        }).then(newRow => {
          // 插入到第一行
          this.tableData.unshift(newRow)
          this.$refs[this.refname].syncData().then(() => this.$refs[this.refname].setActiveRow(newRow))
        })
      },
      async submitData() {
        const errMap = await this.$refs[this.refname].validate().catch(errMap => errMap)
        if (errMap) {
          this.$message.error("校验不通过!");
        } else {
          if (this.invoiceActive == 3){
            // //判断所有服务费的totalAmount等于销项税加服务费
            // let totalServiceFee = this.names.totalServiceFee;
            // for(let i=0;i<this.datas.length;i++){
            //
            // }
debugger
            // 分别计算两条数据的各类型的总和
            const split2 = this.splitData(this.tableData);
            for(let i=0;i<this.datasCopy.length;i++){
              let item=this.datasCopy[i];
              var amount1=split2[item.invoiceItemId];
              if(amount1!=item.totalAmount){
                let name=this.dicts.codeMap[item.invoiceItemId];
                this.$message.success(name+"需等于"+item.totalAmount+"元");
                return false
              }
            }
          }
          if(this.datas.length > 0){
            saveSplitInvoice(this.noticeId, this.invoiceActive, this.tableData).then(res => {
              if (res.data.code == 0) {
                this.$message.success("发票拆分成功");
                // this._getListpage();
                this.$emit("update:dialogInvoiceVisible", false)
                this.$emit("closeDialog")
              }
            })
          }else{
            this.$emit("update:dialogInvoiceVisible", false)
            this.$emit("closeDialog")
          }
        }

      },
      splitData(temp){
        let splitObj={};
        let amountObj = {};
        for(var i = 0;i < temp.length;i++){
          if(splitObj[temp[i].invoiceItemId]){
            splitObj[temp[i].invoiceItemId].push(parseFloat(temp[i].totalAmount).toFixed(2));
          }else{
            let obj = {};
            obj[temp[i].invoiceItemId] = [temp[i].totalAmount];
            splitObj = Object.assign(splitObj,obj)
          }
        }
        for(var key in splitObj){
          amountObj[key] = floatSum(splitObj[key])
        }

        return amountObj
      },
      footerMethod({columns, data}) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计'
            }
            if (this.sumItem.includes(column.property)) {
              return this.$options.filters['moneyFilter'](this.$utils.sum(data, column.property))
              // return this.$utils.sum(data, column.property)
            }
            return null
          })
        ]
      },
      deleteData(row,rowIndex) {
        var that = this;
        this.$nextTick(() => {
          this.$confirm('您确定要删除该数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.tableData.splice(rowIndex,1);
            that.$message.success('删除成功!')
          }).catch(() => {
          });
        })
      },
      backPrev() {
        this.$emit('backPrev')
      },
      // 格式化空值
      formatEmpty({cellValue}) {
        if (cellValue) {
          return cellValue
        } else {
          return "--"
        }
      },
    }
  };
</script>

<style scoped lang="scss">

  .invoiceTable {
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background: #fff;
    padding: 14px 20px;
    .vxe-table .vxe-body--column:not(.col--ellipsis),
    .vxe-table .vxe-footer--column:not(.col--ellipsis),
    .vxe-table .vxe-header--column:not(.col--ellipsis) {
      padding: 0;
    }
    .vxe-table--filter-wrapper .vxe-default-input,
    .vxe-table--filter-wrapper .vxe-default-select,
    .vxe-table--filter-wrapper .vxe-default-textarea,
    .vxe-table .vxe-default-input,
    .vxe-table .vxe-default-select,
    .vxe-table .vxe-default-textarea {
      height: 26px;
      padding: 0 6px;
      color: #000;
      font-size: 12px;
    }
  }

</style>
